import React from "react";

// A render error in one template used to unmount the whole app, and the
// app reuses each editor iframe for every page it shows, so one bad page
// left that pane blank for every later page too. The boundary contains the
// failure to the payload that caused it: the next payload posted into this
// frame (a new page, or the same page re-posted) renders normally.
export default class PageErrorBoundary extends React.Component {
  state = { failedPage: null };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  static getDerivedStateFromProps(props, state) {
    if (state.failed) return { failed: false, failedPage: props.page };
    return null;
  }

  componentDidCatch(error) {
    console.error("Page render failed", error);
  }

  render() {
    const { page, children } = this.props;
    return this.state.failedPage === page ? null : children;
  }
}
